import type { PersonInvolvement } from "../types/involvement.js";
import type { PersonState } from "../types/personState.js";
import { isInvolvementLive } from "./isInvolvementLive.js";
import { requiredInvolvementKinds } from "./requiredInvolvementKinds.js";

/**
 * Whether the person's case can run yet, worked out from their involvements
 * at this instant. Never stored, because an involvement expiring changes the answer
 * without any request to recalculate it.
 */
export const personStateOf = (
  person: { archivedAt: Date | null },
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "endedAt" | "expiresAt"
  >[],
  now: Date = new Date(),
): PersonState => {
  if (person.archivedAt !== null) {
    return { kind: "archived" };
  }

  const held = new Set(
    involvements
      .filter((involvement) => isInvolvementLive(involvement, now))
      .map((involvement) => involvement.kind),
  );

  const missing = requiredInvolvementKinds.filter((kind) => !held.has(kind));

  return missing.length === 0
    ? { kind: "active" }
    : { kind: "unassigned", missing };
};
